import React, { Fragment } from 'react'
import { useCheckoutForm, CheckoutFormProps } from './useCheckoutForm'
import styles from './CheckoutForm.module.scss'

const CheckoutForm: React.FC<CheckoutFormProps> = (
  props: CheckoutFormProps
) => {
  const { isLoading, formData, handleInputChange, handleSubmit } =
    useCheckoutForm(props)

  return (
    <form className={styles.form_container} onSubmit={handleSubmit}>
      <p className={styles.instruction}>Please fill in your delivery details</p>

      <div className={styles.input_group}>
        <label htmlFor='customerName'>
          <i className='bi bi-person me-2'></i>Full Name
        </label>
        <input
          type='text'
          id='customerName'
          name='customerName'
          placeholder='e.g. John Doe'
          value={formData.customerName}
          onChange={handleInputChange}
          required
        />
      </div>

      <div className={styles.input_group}>
        <label htmlFor='phoneNumber'>
          <i className='bi bi-telephone me-2'></i>Phone Number
        </label>
        <input
          type='tel'
          id='phoneNumber'
          name='phoneNumber'
          placeholder='e.g. +961 70 123 456'
          value={formData.phoneNumber}
          onChange={handleInputChange}
          required
        />
      </div>

      <div className={styles.input_group}>
        <label htmlFor='location'>
          <i className='bi bi-geo-alt me-2'></i>Delivery Location
        </label>
        <input
          type='text'
          id='location'
          name='location'
          placeholder='Street name, Building, Floor...'
          value={formData.location}
          onChange={handleInputChange}
          required
        />
      </div>

      <div className={styles.input_group}>
        <label htmlFor='notes'>
          <i className='bi bi-pencil me-2'></i>Order Notes (Optional)
        </label>
        <textarea
          name='notes'
          id='notes'
          placeholder='Any special instructions for the kitchen or driver...'
          rows={4}
          value={formData.notes}
          onChange={handleInputChange}
        ></textarea>
      </div>
      <div className={styles.action_area}>
        <button
          type='submit'
          className={styles.submit_btn}
          disabled={isLoading}
        >
          {isLoading ? (
            <Fragment>
              <i className={`bi bi-arrow-repeat ${styles.spinner} me-2`}></i>
              Processing...
            </Fragment>
          ) : (
            <Fragment>
              Confirm Order <i className='bi bi-bag-check-fill ms-2'></i>
            </Fragment>
          )}
        </button>
      </div>
    </form>
  )
}

export default CheckoutForm
